import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import InputBox from './InputComponents/inputbox';
import { FormContext } from '../../reusable-components/InputFields/FormContext'
import Element from '../../reusable-components/InputFields/input';
import Select from "react-select";
import { v4 } from "uuid";
import * as Icon from "react-bootstrap-icons";
import styled from 'styled-components';
import { logout } from "../../utils";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { client_onboarding, task_creation, staff_creation, custom } from './purposeformlayouts';
import { toast } from "react-toastify";
import { getFromLS } from '../../utils/storage';
import { makeCygnusApiCall } from '../../api/api';
import { CustomButton } from '../../reusable-components/CustomButtonComponent/button';

const ColumnContainer = styled.div`
  margin: 8px;
  border: 0px solid #bbb;
  border-radius: 2px;
  width: 100%;
  background-color: #fbfbfc;
  display: flex;
  flex-direction: column;
`;

const TEMPLATE_NAME_MAPPER = {
    "Client Onboarding": client_onboarding,
    "Task Creation": task_creation,
    "Staff Creation": staff_creation,
    "Custom": custom
}

const CreateFormModal = (props) => {
    const [formName, setFormName] = useState(props.formname)
    const [formNameFlag, setFormNameFlag] = useState(false)
    useEffect(() => {
        if (!formNameFlag) {
            if (props.formname !== undefined) {
                setFormName(props.formname)
                setFormNameFlag(true)
            }
        }
    }, [props.formname])

    const [flag, setFlag] = useState(props.flag)
    useEffect(() => {
        setFlag(props.flag)
    }, [props.flag])

    const [purposeOptions, setPurposeOptions] = useState([
        { "label": "Client Onboarding", "value": "Client Onboarding" },
        { "label": "Task Creation", "value": "Task Creation" },
        { "label": "Staff Creation", "value": "Staff Creation" },
        { "label": "Custom", "value": "Custom" }
    ])
    const [selectedPurpose, setSelectedPurpose] = useState(props.formpurpose !== undefined ? props.formpurpose : purposeOptions[0])
    const [purposeFlag, setPurposeFlag] = useState(false)
    const [templateOptions, setTemplateOptions] = useState([{ "label": "", "value": "" }])
    const [selectedTemplate, setSelectedTemplate] = useState(props.formtemplate !== undefined ? props.formtemplate : templateOptions[0])
    const [templateFlag, setTemplateFlag] = useState(false)

    useEffect(() => {
        if (!purposeFlag) {
            if (props.formpurpose !== undefined) {
                setSelectedPurpose(props.formpurpose)
                setPurposeFlag(true)
            } else {
                setSelectedPurpose(purposeOptions[0])
            }
        }
    }, [props.formpurpose])

    useEffect(() => {
        if (!templateFlag) {
            if (props.formtemplate !== undefined) {
                setSelectedTemplate(props.formtemplate)
                setTemplateFlag(true)
            } else {
                setSelectedPurpose(templateOptions[0])
            }
        }
    }, [props.formtemplate])

    const [allTemplates, setAllTemplates] = useState({
        "Client Onboarding": [],
        "Staff Creation": [],
        "Task Creation": []
    })
    useEffect(() => {
        if (props.templates !== undefined) {
            setAllTemplates(props.templates)
        }
    }, [props.templates])

    useEffect(() => {
        props.setformname(formName)
    }, [formName])

    useEffect(() => {
        props.setformpurpose(selectedPurpose)
    }, [selectedPurpose])

    useEffect(() => {
        props.settemplate(selectedTemplate)
    }, [selectedTemplate])

    useEffect(() => {
        console.log("ALL TEMPLATES: ", allTemplates)
        if (selectedPurpose["value"] !== "" && selectedPurpose["value"] !== "Custom") {
            const options = []
            for (let template of allTemplates[selectedPurpose["value"]]) {
                options.push({ "label": template["FormName"], "value": template["FormName"] })
            }
            setTemplateOptions(options)
        }
    }, [selectedPurpose, allTemplates])


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="custom-backdrop"
            backdrop="static"
            centered
            className='form-modal'
            scrollable="false"
        >
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <Row className='no-gutter'>
                    <Col md={selectedPurpose["value"] === "Custom" ? 8 : 4}>
                        <div className="mb-3">
                            <label className="form-label move-left">Form name</label>
                            <input type="text" className="form-control move-left custom-input"
                                placeholder={'Enter a name for your form'}
                                value={formName}
                                onChange={(event) => setFormName(event.target.value)}
                            />
                        </div>
                    </Col>
                    <Col md={4} className="custom-select-holder">
                        <label className="form-label move-left">Form purpose</label>
                        <Select
                            options={purposeOptions}
                            value={selectedPurpose}
                            defaultValue={purposeOptions[0]}
                            onChange={(event) => setSelectedPurpose(event)}
                            placeholder={""}
                            aria-label="Default"
                            autosize={true}
                            className='custom-select '
                            classNamePrefix="react-select"
                        />
                    </Col>
                    {
                        selectedPurpose["value"] !== "Custom" ?
                            <Col md={4} className="custom-select-holder">
                                <label className="form-label move-left">Form template</label>
                                <Select
                                    options={templateOptions}
                                    value={selectedTemplate}
                                    defaultValue={templateOptions[0]}
                                    onChange={(event) => setSelectedTemplate(event)}
                                    placeholder={""}
                                    aria-label="Default"
                                    autosize={true}
                                    className='custom-select '
                                    classNamePrefix="react-select"
                                />
                            </Col>
                            : <></>
                    }
                </Row>
            </Modal.Body>
            <Modal.Footer className="action-footer">
                <Button className="custom-button" style={{ padding: "10px 20px" }} onClick={() => props.createform(selectedPurpose.value, selectedTemplate.value)} >
                    {flag ? "Update" : "Create form"}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

const FormLayout = (props) => {
    let drag_data_format = {
        fields: {
        },
        columns: {
            'column': {
                id: 'column',
                fieldIds: [],
            },
        }
    }
    const [initialData, setInitialData] = useState(drag_data_format)
    const [fields, setFields] = useState([])
    const [previewComponents, setPreviewComponents] = useState([])
    const [createFormModalShow, setCreateFormModalShow] = useState(false)
    const [fullWindowModalShow, setFullWindowModalShow] = useState(false)
    const [formName, setFormName] = useState("")
    const [formId, setFormId] = useState("")
    const [selectedTemplate, setSelectedTemplate] = useState()
    const [selectedPurpose, setSelectedPurpose] = useState()
    const [allTemplates, setAllTemplates] = useState({
        "Client Onboarding": [],
        "Staff Creation": [],
        "Task Creation": []
    })
    const [update, setUpdate] = useState(false)
    const [final, setFinal] = useState(false)
    const [buttonFlag, setButtonFlag] = useState(false)

    useEffect(() => {
        const getGroupedTemplates = async () => {
            const data = await makeCygnusApiCall({
                type: "GET",
                payload: {},
                url: "/forms/templates/grouped/",
                show_message: false,
                customized_success_message: "Successfully fetched your templates",
                customized_failure_message: "Unable to fetch your templates, please try again. If the problem persists, please contact support and attach a screenshot.",
                customized_error_message: "Error occured while fetching your templates, please contact support and attach a screenshot.",
                isblob: false
            })
            if (data.success) {
                setAllTemplates(data["data"])
            }
        }
        getGroupedTemplates()
    }, [])

    /**
     * Setting the first field by default on first load
     */
    useEffect(() => {
        if (Object.keys(props.createformoption).length > 0) {
            // console.log("PROPS for LAYOUT:", props.createformoption)
            setCreateFormModalShow(false)
            setFormName(props.createformoption.form_name)
            setSelectedPurpose({ "label": props.createformoption.form_purpose, "value": props.createformoption.form_purpose })
            setSelectedTemplate({ "label": props.createformoption.form_template, "value": props.createformoption.form_template })
            setInitialData(props.createformoption.initial_data)
            if (props.createformoption.id !== undefined) {
                setUpdate(true)
                setFormId(props.createformoption.id)
            }
            setButtonFlag(true)
        } else {
            setButtonFlag(false)
            setCreateFormModalShow(true)
            const id = v4()
            drag_data_format.columns["column"].fieldIds.push(id)
            Object.assign(drag_data_format.fields, {
                [id]: {
                    "id": id, "schema": [
                        {
                            "id": id,
                            "label": "Untitled",
                            "mandatory": false,
                            "disabled": false,
                            "placeholder": "Untitled",
                            "type": "text",
                            "example": null,
                            "pivot": true,
                            "pivotreverse": false,
                            "category": "H1",
                            "value": "",
                            "options": [{ "id": id, "label": "Untitled", "value": "Untitled" }],
                            "width": 12
                        }
                    ]
                }
            })
            setInitialData(drag_data_format)
        }
    }, [])

    useEffect(() => {
        console.log("INITIAL DATA: ", initialData)
    }, [initialData])

    /**
     * Update fields and preview components everytime initialData changes
     */
    useEffect(() => {
        console.log("INITIAL DATA: ", initialData.columns["column"].fieldIds.map(fieldId => initialData.fields[fieldId]))
        setFields(initialData.columns["column"].fieldIds.map(fieldId => initialData.fields[fieldId]))
        const preview = []
        if (Object.keys(initialData.fields).length > 0) {
            for (let fieldId of initialData.columns["column"].fieldIds) {
                const schema = initialData.fields[fieldId]["schema"]
                preview.push(...schema)
            }
        }
        setPreviewComponents(preview)
    }, [initialData])

    /**
     * Create a new component and add it to the initial data
     */
    const addInputBox = () => {
        const id = v4()
        const newInitialData = Object.assign({}, initialData)
        newInitialData.columns["column"].fieldIds.push(id)
        Object.assign(newInitialData.fields, {
            [id]: {
                "id": id, "schema": [
                    {
                        "id": id,
                        "label": "Untitled",
                        "mandatory": false,
                        "approval": false,
                        "disabled": false,
                        "placeholder": "Untitled",
                        "type": "text",
                        "example": null,
                        "pivot": true,
                        "pivotreverse": false,
                        "category": "H1",
                        "value": "",
                        "options": [{ "id": id, "label": "Untitled", "value": "Untitled" }],
                        "width": 12
                    }
                ]
            }
        })
        setInitialData(newInitialData)
    }
    const [saveFormApiFlag, setSaveFormApiFlag] = useState()
    const saveForm = async () => {
        setSaveFormApiFlag(true)
        if (update) {
            let payloadFormat;
            payloadFormat = {
                "FirmFormId": formId,
                "FormName": formName,
                "FormDescription": "",
                "FormPurpose": selectedPurpose.value,
                "InputStructure": initialData,
                "PreviewStructure": previewComponents
            }
            console.log("PAYLOAD FORMAT: ", payloadFormat)
            const _ = await makeCygnusApiCall({
                type: "PUT",
                payload: payloadFormat,
                url: "/forms/",
                show_message: false,
                customized_success_message: "Form successfully updated.",
                customized_failure_message: "Unable to update your form, please try again. If the problem persists, please contact support and attach a screenshot.",
                customized_error_message: "Error occured while updating your form, please contact support and attach a screenshot.",
                isblob: false
            })
        } else {
            let payloadFormat;
            payloadFormat = {
                "FormName": formName,
                "FormDescription": "",
                "FormPurpose": selectedPurpose.value,
                "InputStructure": initialData,
                "PreviewStructure": previewComponents
            }
            console.log("PAYLOAD FORMAT: ", payloadFormat)
            const _ = await makeCygnusApiCall({
                type: "POST",
                payload: payloadFormat,
                url: "/forms/",
                show_message: false,
                customized_success_message: "Form successfully created.",
                customized_failure_message: "Unable to create your form, please try again. If the problem persists, please contact support and attach a screenshot.",
                customized_error_message: "Error occured while creating your form, please contact support and attach a screenshot.",
                isblob: false
            })
        }
        setSaveFormApiFlag(false)
    }

    /**
     * Update the values of fields in the PREVIEW form
     * @param {*} field_id: ID of field to be updated 
     * @param {*} event: The trigger event of input in preview form
     */
    const handleChange = (field_id, event) => {
        const newList = [...previewComponents]
        newList.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                switch (type) {
                    case 'checkbox':
                        field['value'] = event.target.checked;
                        break;

                    case 'select':
                        field['value'] = event.value;
                        break;

                    case 'file':
                        field['value'] = event[0];
                        break;

                    case 'date':
                        field['value'] = event;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            const newListTwo = [...newList]
            setPreviewComponents(newListTwo)
        })
    }

    /**
     * Replace the schema with received component 
     * @param {*} field_id: ID of field to be updated
     * @param {*} components: Field component 
     */
    const updateFieldSchema = (field_id, components) => {
        const newInitialData = Object.assign({}, initialData)
        if (Object.keys(newInitialData.fields).length > 0) {
            newInitialData.fields[field_id]["schema"] = components
            setInitialData(newInitialData)
        }
    }

    /**
     * Remove the input box
     * @param {*} inputboxid: The id of input box to be deleted
     */
    const removeInputBox = (inputboxid) => {
        const newInitialData = Object.assign({}, initialData)
        delete newInitialData.fields[inputboxid]
        const index = newInitialData.columns["column"].fieldIds.findIndex((obj) => obj === inputboxid)
        if (index !== -1) {
            newInitialData.columns["column"].fieldIds.splice(index, 1)
        }
        setInitialData(newInitialData)
    }

    /**
     * Dragging logic to reorder the input boxes 
     * @param {*} result: The properties of draggable and droppable components in DragDropContext
     * @returns: Updates the initial data with updated order
     */
    const onDragEnd = (result) => {
        const { destination, source, draggableId } = result;
        const initialDataCopy = JSON.parse(JSON.stringify(initialData))
        if (!destination) {
            return;
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }

        const column = initialDataCopy.columns[source.droppableId];
        const newFieldIds = Array.from(column.fieldIds);
        newFieldIds.splice(source.index, 1);
        newFieldIds.splice(destination.index, 0, draggableId);

        const newColumn = {
            ...column,
            fieldIds: newFieldIds,
        };

        const newState = {
            ...initialDataCopy,
            columns: {
                ...initialDataCopy.columns,
                [newColumn.id]: newColumn,
            },
        };
        setInitialData(newState);
    }

    const createForm = (purpose, template) => {
        console.log("PURPOSE: ", purpose)
        console.log("TEMPLATE: ", template)
        const data = allTemplates[purpose].filter((t) => t["FormName"] === template)
        console.log("DATA: ", JSON.parse(data[0]["InputStructure"]))
        if (data.length > 0) {
            setInitialData(JSON.parse(data[0]["InputStructure"]))
        }
        setCreateFormModalShow(false)
    }



    const FullWindowModal = (props) => {
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                centered
                className="full-modal"
                scrollable="false"
            >
                <Modal.Header className="preview-modal-header" closeButton>
                </Modal.Header>
                <Modal.Body className="preview-modal">
                    <Row className='no-gutter'>
                        <Col md={1}></Col>
                        <Col md={10}>
                            <h4 style={{ margin: "10px 0px 20px 0px", textAlign: "center" }}>Preview</h4>
                            <FormContext.Provider value={{ handleChange }}>
                                <Form className='no-padding'>
                                    <Row className='no-gutter'>
                                        {
                                            previewComponents &&
                                            previewComponents.map((field, i) =>
                                                <Element
                                                    key={i}
                                                    field={field}
                                                />
                                            )
                                        }
                                    </Row>
                                </Form>
                            </FormContext.Provider>
                        </Col>
                        <Col md={1}></Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="action-footer">
                </Modal.Footer>
            </Modal>
        )
    }

    return (
        <>
            <CreateFormModal
                show={createFormModalShow}
                onHide={() => setCreateFormModalShow(false)}
                formname={formName}
                formpurpose={selectedPurpose}
                setformname={(name) => setFormName(name)}
                setformpurpose={(purpose) => setSelectedPurpose(purpose)}
                formtemplate={selectedTemplate}
                templates={allTemplates}
                settemplate={(template) => setSelectedTemplate(template)}
                flag={buttonFlag}
                createform={(purpose, template) => createForm(purpose, template)}
            />
            <FullWindowModal
                show={fullWindowModalShow}
                onHide={() => setFullWindowModalShow(false)}
            />
            <Row className="no-gutter">
                <Col md={6} className='flex-column-center-center'>
                    <div className='flex-row-space-center' style={{ width: "100%", padding: "10px 0px" }}>
                        <h3 style={{ width: "fit-content", marginBottom: 10 }}>{formName === "" ? "Untitled form" : formName}</h3>
                        <Icon.Pencil style={{ fontSize: 20, cursor: "pointer", width: "fit-content", margin: "0px 10px 0px 0px" }} onClick={() => setCreateFormModalShow(true)} />
                    </div>
                    <Row className='flex-row-center-center' style={{ width: "100%", padding: "10px 0px" }}>
                        <Col md={3}>
                            <Button className="custom-button"
                                style={{
                                    display: "inline-block",
                                    padding: "10px 10px",
                                }}
                                onClick={() => addInputBox()} >
                                <Icon.PlusCircleFill style={{ fontSize: 20, margin: "0px 10px 0px 0px" }} />
                                Create new field
                            </Button>
                        </Col>
                        <Col md={5}></Col>
                        <Col md={2}>
                            <div className={"pad-trbl-10 pivotreverse-check-holder"}>
                                <label style={{ margin: "0px 5px", fontWeight: 700 }}>Finalized</label>
                                <input type="checkbox" className={"form-check-input move-left custom-check-input pivot-check"}
                                    style={{ margin: "0px 0px" }}
                                    checked={final}
                                    onChange={event => setFinal(event.target.checked)}
                                    autoComplete="new-password"
                                />
                            </div>
                        </Col>
                        <Col md={2}>
                            <CustomButton
                                progress={saveFormApiFlag}
                                onclick={() => saveForm()}
                                content={saveFormApiFlag ? `Saving ${final ? "form" : "draft"}` : `Save ${final ? "form" : "draft"}`}
                                disable={saveFormApiFlag}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={6} className='flex-row-space-center'>
                    <h4></h4>
                    <h4 style={{ margin: "10px 0px 20px 0px", textAlign: "center" }}>Preview</h4>
                    <Button className="custom-button" style={{ padding: "10px 10px", marginRight: 10 }} onClick={() => setFullWindowModalShow(true)} >
                        <Icon.ArrowUpRightSquareFill style={{ fontSize: 20, width: "fit-content", margin: "0px 10px 0px 0px" }} />
                        Show in full window
                    </Button>
                </Col>
            </Row>
            <Row className="no-gutter">
                {
                    initialData !== undefined ?
                        <Col md={6} className="yscrollable">
                            <DragDropContext
                                onDragEnd={onDragEnd}
                            >
                                <ColumnContainer
                                    key={initialData.columns["column"].id}
                                    column={initialData.columns["column"]}
                                >
                                    <Droppable droppableId={"column"}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                isDraggingOver={snapshot.isDraggingOver}
                                            >
                                                {fields.map((field, index) =>
                                                    <Draggable key={field.id} draggableId={field.id} index={index}>
                                                        {(provided, snapshot) => (
                                                            <div
                                                                className='flex-row-center-start draggable-inputbox-wrapper'
                                                                style={{ margin: "10px 0px" }}
                                                                ref={provided.innerRef}
                                                                isDragging={snapshot.isDragging}
                                                                {...provided.draggableProps}
                                                            >
                                                                <InputBox
                                                                    inputboxid={field.id}
                                                                    existingfieldschema={field.schema}
                                                                    updatefieldschema={(components) => updateFieldSchema(field.id, components)}
                                                                    key={field.id}
                                                                    removeinputbox={(inputboxid) => removeInputBox(inputboxid)}
                                                                    provided={provided}
                                                                />
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                )}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </ColumnContainer>
                            </DragDropContext>
                        </Col>
                        :
                        <></>
                }
                <Col md={6} className="yscrollable">
                    <FormContext.Provider value={{ handleChange }}>
                        <Form className='no-padding'>
                            <Row className='no-gutter'>
                                {
                                    previewComponents &&
                                    previewComponents.map((field, i) =>
                                        <Element
                                            key={i}
                                            field={field}
                                        />
                                    )
                                }
                            </Row>
                        </Form>
                    </FormContext.Provider>
                </Col>
            </Row >
        </>
    )
}

export default FormLayout;